"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    icon = null,
    action,
    tokens = {},
    variant = {},
    ...iconButtonProps
  } = _ref;
  const variantWithAction = action && !variant.action ? {
    ...variant,
    action
  } : variant;
  const {
    icon: themeIcon
  } = (0, _componentsBase.useThemeTokens)('IconButton', tokens, variantWithAction);
  return (
    /*#__PURE__*/
    // If we want the arrow icons to have directional animation instead of scale, we can pass
    // either appropriate iconTransateX/Y here, or define and pass variants like { direction: 'left' }
    // which have theme rules that set `iconTranslateX` tokens in the theme rules and unset `iconScale`.
    (0, _jsxRuntime.jsx)(_componentsBase.IconButton, {
      ref: ref,
      ...iconButtonProps,
      tokens: tokens,
      variant: variant,
      icon: icon ?? themeIcon
    })
  );
});
const multiBrandIconNames = ['add', 'subtract', 'close', 'play', 'moveUp', 'moveDown', 'moveLeft', 'moveRight', 'expand'];
IconButton.displayName = 'IconButton';
const propsWithoutIcon = _ref2 => {
  let {
    icon,
    ...props
  } = _ref2;
  return props;
};
IconButton.propTypes = {
  ...propsWithoutIcon(_componentsBase.IconButton.propTypes),
  tokens: (0, _componentsBase.getTokensPropType)('IconButton'),
  /**
   * To set the icon to a multi-brand compatabile icon
   */
  action: _propTypes.default.oneOf(multiBrandIconNames),
  /**
   * To set a custom icon
   */
  icon: _propTypes.default.func
};
var _default = exports.default = IconButton;